import React from 'react';
import { Translate } from 'core/translate';
import { ButtonIcon, ButtonText, PrimaryButton } from 'core/controls';

const InventorySummary = ({
  cta,
  count,
  showSpeedBump,
  showCount,
  enabled
}) => {
  if (!enabled) {
    return null;
  }

  count = count === 0 ? '' : count;

  const speedBump = (cta, event) => {
    if (cta.speedBump) {
      event.preventDefault();
      showSpeedBump(cta);
    }
  };

  return (
    <div className="inventory-summary">
      {showCount &&
        count && (
          <div className="inventory-summary__text">
            <span className="inventory-summary__count">{count}&nbsp;</span>
            <span className="inventory-summary__label">
              <Translate value="vehicles.near" />
            </span>
          </div>
        )}
      <PrimaryButton
        as="a"
        href={cta.url}
        onClick={event => speedBump(cta, event)}
        className="button--inline-flex inventory-summary__button">
        <ButtonIcon name="locate" />
        <ButtonText>{cta.label}</ButtonText>
      </PrimaryButton>
    </div>
  );
};

export default InventorySummary;
